import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CashFund, CashFundsService, Identity } from '@libs/core/api';

import { ProjectsService } from '@front-end/core/services';
import { LoadingService, ToastService } from '@libs/ui/uikit';
import { tap } from 'rxjs';
import { FundCashPurchaseService } from '../../fund-cash-purchase.service';

@Component({
  selector: 'front-end-fund-cash-transfer-detail-modal',
  templateUrl: './fund-cash-transfer-detail-modal.component.html',
  styleUrls: ['./fund-cash-transfer-detail-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashTransferDetailModalComponent {
  @Input() purchase!: CashFund;
  @Input() identity!: Identity;

  project$ = this.projectService.selectedProject$;

  constructor(
    private modalController: ModalController,
    private projectService: ProjectsService,
    private cashFundService: CashFundsService,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private fundCashPurchaseService: FundCashPurchaseService
  ) {}

  cancel() {
    this.modalController.dismiss(undefined, 'cancel');
  }

  onApprovalResult(approved: boolean) {
    const action = approved
      ? this.cashFundService.putTransferAccept({
          id: this.purchase?.id as number,
        })
      : this.cashFundService.putTransferReject({
          id: this.purchase?.id as number,
        });
    action
      .pipe(
        tap(() => {
          this.modalController.dismiss(approved, 'transfer-status');
        }),
        this.loadingService.withLoading(),
        this.toastService.catchErrorWithToast()
      )
      .subscribe();
  }
}
